import React from 'react';

import { Typography } from 'antd';

import type IProduct from 'interfaces/IProduct';
import { CHECKOUT_SUN_URL } from 'settings';

import ClipboardField from '../../ClipboardField';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

const CheckoutSunLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  let urlCheckoutSun = `${CHECKOUT_SUN_URL}/${currentProduct.hash ?? currentProduct.id}`;

  if (isAffiliated) {
    urlCheckoutSun += `?a=${currentUserId}`;
  }

  return (
    <div className='flex flex-col gap-2'>
      <Typography.Title level={5} className='!mb-0'>
        Eduzz Checkout
      </Typography.Title>

      {!physicalProductPending && (
        <div className='w-full max-w-md'>
          <ClipboardField value={urlCheckoutSun} />
        </div>
      )}
    </div>
  );
};

export default CheckoutSunLink;
